<div class="wrapper selenium-filter-by-discipline">
    <ng-select
        [items]="disciplines"
        bindLabel="title"
        dropdownPosition="bottom"
        [multiple]="false"
        [hideSelected]="true"
        [searchable]="false"
        [clearable]="false"
        [markFirst]="true"
        placeholder="Discipline"
        [(ngModel)]="selectedDiscipline"
        (change)="changeDiscipline($event, selectedDiscipline)"
        class="dropdown"
    >
    </ng-select>
</div>
